import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  titleRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.75rem',
    marginRight: '0.5rem',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start',
  },
  listItem: {
    width: '100%',
    padding: '0 4px 0 0',
    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.common.greyLight}`,
    },
  },
  invoiceActionButton: {
    fontSize: '0.75rem',
  },
  divider: {
    margin: '0 0.5rem',
  },
  addItemButton: {
    marginRight: '0.75rem',
  },
  resume: {
    backgroundColor: '#F9F9F9',
    borderRadius: '4px',
    padding: '0.5rem 1rem',
  },
  total: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  button: {
    fontSize: theme.typography.pxToRem(13),
    textTransform: 'capitalize',
  },
}));

const collapseCardStyles = makeStyles((theme) => ({
  root: {
    marginTop: 0,
    marginBottom: 20,
    '& button': {
      borderRadius: 4,
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: theme.palette.tables.header,
    border: `1px solid ${theme.palette.dividers.primary}`,
    boxShadow: 'none',
    color: theme.palette.widgets.text.primary,
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: theme.palette.tables.header,
      border: `1px solid ${theme.palette.dividers.primary}`,
      boxShadow: 'none',
      color: theme.palette.widgets.text.primary,
    },
  },
}));

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 'bold',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
      textAlign: 'right',
    },
  };
});

export { useStyles, collapseCardStyles, listTextStyles };
